<div class="dd-slot">
  <div class="ddpanel" [ngClass]="{ 'ddpanel_shadow': arrowState === 'expanded', 'error': error }">
    <div class="ddpanel-input">
      <ion-input
        class="ddpanel-input_field"
        [placeholder]="placeholder"
        [readonly]="true"
        [value]="value"
      ></ion-input>
      <ion-icon
        [@toggleArrow]="{ value: arrowState }"
        size="medium" 
        src="assets/dropdown_arrow.svg" 
        class="ddpanel-input_arrow" 
        (click)="onToggle()"
      ></ion-icon>
    </div>
  
    <ion-accordion-group #ddPanel [value]="arrowState" class="ddpanel-dd">
      <ion-accordion value="expanded" toggleIcon="" class="ddpanel-dd">
        <ion-item class="ddpanel-dd" slot="header"></ion-item>
        <div slot="content" class="ddpanel-dd_list">
          <span 
            class="ddpanel-dd_list-item"
            [ngClass]="{ 'selected': value === item }"
            *ngFor="let item of values"
            (click)="selectValue(item)"
          >{{ item }}</span>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</div>